/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var e;null===(e=window.HTMLSlotElement)||void 0===e||e.prototype.assignedElements;
